import {CdAddedMeasureDetail} from '../../../interfaces/care/cd-care-plan/cd-added-measure-detail';
import {CdAddedMeasureDetailOption} from '../../../interfaces/care/cd-care-plan/cd-added-measure-detail-option';
import {CdAddedMeasureDetailOptionFactory} from './cd-added-measure-detail-option-factory';


export class CdAddedMeasureDetailFactory {
  public static fromObject(cdAddedMeasureDetail: any): CdAddedMeasureDetail {
    return new class implements CdAddedMeasureDetail {
      cdAddedMeasureDetailOptions: CdAddedMeasureDetailOption[] =
        cdAddedMeasureDetail.measure_detail_options ?
          CdAddedMeasureDetailOptionFactory.fromArray(cdAddedMeasureDetail.measure_detail_options) : [];
      cdItemType: number = cdAddedMeasureDetail.type;
      definition: string = cdAddedMeasureDetail.definition;
      id: number = cdAddedMeasureDetail.id;
      isAdded: boolean = cdAddedMeasureDetail.is_added;
      itemId: number = cdAddedMeasureDetail.c_care_plan_item_able_id;
      name: string = cdAddedMeasureDetail.name;
      taxonomy: string = cdAddedMeasureDetail.taxonomy;
      comment: string = cdAddedMeasureDetail.comment;
    };
  }

  public static fromArray(cdAddedMeasureDetails: any[]): CdAddedMeasureDetail[] {
    return cdAddedMeasureDetails.map(
      _cdAddedMeasureDetail => CdAddedMeasureDetailFactory.fromObject(_cdAddedMeasureDetail)
    );
  }
}
